import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getPlaces, deletePlace, updatePlacesPagination } from '../../store/actions/place/place_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import ActionsComponent from '../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const PlacesTable = ({ places: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getPlaces({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.PLACE}/${uuid}`);
    }

    const handleDeletePlace = (uuid) => {
        dispatch(deletePlace(uuid))
            .then(() => dispatch(getPlaces({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Naziv</TableCell>
                        <TableCell align="center">Adresa</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, name, address, deletable }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">{ name }</TableCell>
                            <TableCell align="center">{ address }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeletePlace(uuid)}
                                    deletable={deletable}
                                    label="mesto"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updatePlacesPagination}
                 />
            </Table>
        </Paper>
    )
}

PlacesTable.propTypes = {
    places: PropTypes.object
}

const mapStateToProps = (state) => ({
    places: state.places
});

export default connect(mapStateToProps)(PlacesTable);
